define("settings/controllers/subscription/index", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking"], function (_exports, _controller, _object, _service, _utils, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let IndexController = _exports.default = (_class = class IndexController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "cancellation", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "plans", _descriptor5, this);
      _initializerDefineProperty(this, "settings", _descriptor6, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor7, this);
      _defineProperty(this, "defaultDateFormat", 'MMM D, YYYY');
      _initializerDefineProperty(this, "showSocialSetsInfo", _descriptor8, this);
      _initializerDefineProperty(this, "showUserInfo", _descriptor9, this);
      _initializerDefineProperty(this, "showContactUsModal", _descriptor10, this);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get hasCancelledSubscription() {
      return this.subscriptions.hasCurrentSubscription && this.auth.currentAccount.hasActiveCancelledSubscription;
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }
    get isUKTaxEligible() {
      return this.address.shouldDisplayTaxAmount;
    }
    get upcomingSubscriptionPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }
    get canHideAiFeatures() {
      return this.auth.currentAccount.canHideAiFeatures;
    }
    get canAddAiCredits() {
      return this.subscriptionPlan.canAddAiCredits;
    }
    get canUpgrade() {
      return this.subscriptions.canUpgrade;
    }
    get hasUpcomingDowngrade() {
      return this.subscriptions.hasUpcomingDowngrade;
    }
    get hasSubscription() {
      return this.subscriptions.hasCurrentSubscription;
    }
    get upcomingPlanChangesDate() {
      return this.subscription.upcomingPlanChanges.activeAtMoment;
    }
    get upcomingAiCreditsQuantity() {
      return this.subscription.upcomingAiCreditsChanges?.quantity;
    }
    get upcomingAiCreditsChangesDate() {
      return this.subscription.upcomingAiCreditsChanges.activeAtMoment;
    }
    get upcomingSocialSetQuantity() {
      return this.subscription.upcomingSocialSetChanges?.quantity;
    }
    get upcomingSocialSetChangesDate() {
      return this.subscription.upcomingSocialSetChanges?.activeAtMoment;
    }
    get upcomingUserQuantity() {
      return this.subscription.upcomingUserChanges?.quantity;
    }
    get upcomingUserChangesDate() {
      return this.subscription.upcomingUserChanges.activeAtMoment;
    }
    get hasUpcomingAiCreditsChanges() {
      const currentQuantity = this.subscription.additionalAiCredits;
      const upcomingQuantity = this.upcomingAiCreditsQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }
    get hasUpcomingIntervalChanges() {
      const currentInterval = this.subscriptionPlan?.interval;
      const upcomingInterval = this.upcomingSubscriptionPlan?.interval;
      return currentInterval && upcomingInterval && currentInterval !== upcomingInterval;
    }
    get hasUpcomingSocialSetChanges() {
      const currentQuantity = this.subscription.additionalSocialSets;
      const upcomingQuantity = this.upcomingSocialSetQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }
    get hasUpcomingUserChanges() {
      const currentQuantity = this.subscription.additionalUsers;
      const upcomingQuantity = this.upcomingUserQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }
    get showAddressBanner() {
      return this.address.showAddressBanner;
    }
    get showCancelTrialButton() {
      return this.hasActiveTrial && !this.hasCancelledSubscription && !this.subscriptions.isOnCardlessTrial;
    }
    get showCancelPlanButton() {
      // Note: subscriptionPlan.isPaid returns true while on a free trial
      return !this.hasActiveTrial && this.subscriptionPlan.isPaid && !this.hasCancelledSubscription;
    }
    get showChangePlan() {
      return this.canUpgrade || this.hasCancelledSubscription || this.subscriptions.hasActiveTrial;
    }
    get subscription() {
      if (this.subscriptions.subscription?.id) {
        return this.subscriptions.subscription;
      }
      return {
        additionalSocialSets: 0,
        additionalUsers: 0,
        additionalAiCredits: 0
      };
    }
    get yearlyDiscountPercent() {
      const plan = this.plans.getPlan(this.subscriptionPlan.planType);
      // Note: legacy plans may return undefined
      return this.plan == undefined ? '' : plan.yearlyDiscountPercent;
    }
    get isOnAgencyPlan() {
      return this.subscriptions.isOnAgencyPlan;
    }
    get isLegacyAccount() {
      return this.auth.currentAccount.isOnLegacyPlan && !this.auth.currentAccount.pricingV1Free;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get intervalDescription() {
      if (!this.yearlyDiscountPercent) {
        return '';
      }
      return this.subscriptionPlan.isMonthly ? this.intl.t('account.subscription.index.interval.monthly_description', {
        amount: this.yearlyDiscountPercent
      }) : this.intl.t('account.subscription.index.interval.yearly_description', {
        amount: this.yearlyDiscountPercent
      });
    }
    cancelPlan() {
      this.cancellation.startCancellationFlow.perform('subscription');
    }
    cancelTrial() {
      this.cancellation.startCancellationFlow.perform('subscription');
    }
    trackChangePlan(subscription) {
      this.settings.trackChangePlan.perform(subscription);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cancellation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showSocialSetsInfo", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "showUserInfo", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "showContactUsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "cancelPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangePlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangePlan"), _class.prototype)), _class);
});